/**
 * @author Rehan Rizvi
 * @file ServerCall
 * @flow
 */
import Axios from 'axios';
import { spinnerService } from '../../shared/services/spinner.service';
import { logoutUnauthorizedUser } from '../utils/auth.util';
import AlertModal from '../../shared/modals/AlertModal';
import { getData } from '../utils/storage.util';
import CONFIG from '../../configuration';

/**
 * @description This function used to call the apis.
 * @param url Url of the calling api.
 * @param data Data that will be required to call the api
 * @param loderMsg Message which will be shown with loader.
 * @returns Either return the success response or show the error message.
 */
export const serverCalls = async (url, data, loaderMsg, obj, language = 'en', method = 'POST') => {
    spinnerService.show('Oval', loaderMsg);
    try {
        const config = {
            headers: { authorization: `Bearer ${getData('token')}`, language: language }
        };
        let response;
        switch (method.toUpperCase()) {
            case 'GET':
                response = await Axios.get(url, config);
                break;
            case 'POST':
                response = await Axios.post(url, data, config);
                break;
            case 'PUT':
                response = await Axios.put(url, data, config);
                break;
            case 'DELETE':
                response = await Axios.delete(url, config);
                break;
            default:
                throw new Error(`Unsupported HTTP method: ${method}`);
        }

        spinnerService.hide('Oval');
        if (response && response.data && response.data.responseCode == 200) {
            if (url === CONFIG.deleteAudit || CONFIG.deleteCompletedAudit) return response.data;
            return response.data.response;
        } else {
            if (response && response.data && response.data.responseCode == 401) {
                logoutUnauthorizedUser(obj, response.data.message);
            } else {
                AlertModal.showAlert(response.data.message);
                return response.data;
            }
        }
    } catch (error) {
        spinnerService.hide('Oval');
        AlertModal.showAlert(error.message);
        return null;
    }
};
